import { Fragment } from 'react';
import { Button } from '@mui/material';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import ViewInArOutlinedIcon from '@mui/icons-material/ViewInArOutlined';

import { useSessionStore } from 'session/useSessionStore';
import { actionButtonSx } from '../../utils/queueMeta';
import { IItemActionsProps } from '../QueueTypeHandler';

export function QueueSeismicItemActions({ entityKey, onAssociateAttributes, onShowMetadata, isLoadingMetadata, onTraceHeaderInspect }: IItemActionsProps) {
    const tenantToken = useSessionStore(state => state.tenantConfiguration?.tenantToken);

    const handleOpenViewer2D = () => {
        const tenantTokenParam = tenantToken ? `&tenantToken=${tenantToken}` : '';
        const url = `/app-viewer/seismic?volumeToken=${entityKey}${tenantTokenParam}&prepareRenderStep=2`;
        window.open(url, '_blank');
    };

    const handleOpenViewer3D = () => {
        const tenantTokenParam = tenantToken ? `&tenantToken=${tenantToken}` : '';
        const url = `/app-viewer/3dviewer?volumeToken=${entityKey}&type=volume&totalLoadingIterations=2&lineLoadingStep=1${tenantTokenParam}`;
        window.open(url, '_blank');
    };

    return (
        <Fragment>
            <Button size='small' variant='outlined' startIcon={<ViewInArOutlinedIcon sx={{ fontSize: 16 }} />} sx={actionButtonSx} onClick={handleOpenViewer2D}>
                Abrir Viewer 2D
            </Button>
            <Button size='small' variant='outlined' startIcon={<ViewInArOutlinedIcon sx={{ fontSize: 16 }} />} sx={actionButtonSx} onClick={handleOpenViewer3D}>
                Abrir Viewer 3D
            </Button>
            <Button size='small' variant='outlined' startIcon={<AccountTreeOutlinedIcon sx={{ fontSize: 16 }} />} sx={actionButtonSx} onClick={onAssociateAttributes}>
                Associar Atributos
            </Button>
            <Button size='small' variant='outlined' startIcon={<DescriptionOutlinedIcon sx={{ fontSize: 16 }} />} sx={actionButtonSx} onClick={onShowMetadata} disabled={isLoadingMetadata}>
                {isLoadingMetadata ? 'Carregando...' : 'Exibir Metadados'}
            </Button>
            <Button size='small' variant='outlined' startIcon={<TableChartOutlinedIcon sx={{ fontSize: 16 }} />} sx={actionButtonSx} onClick={onTraceHeaderInspect}>
                Trace Header Inspect
            </Button>
        </Fragment>
    );
}
